import { withAuthGate } from '@sunrise-ui/composites';
import { useAuthStore } from '@sunrise-ui/primitives';
import TicketsView from '@templates/TicketsView';
import React from 'react';

function TicketsScreen() {
  const { currentUserId } = useAuthStore();

  return <TicketsView userId={currentUserId} />;
}

export default withAuthGate(TicketsScreen);
